import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";

import truckEmpty from "assets/images/truck-empty.png";
import { routes } from "constants/routes";
import { usePullToRefresh } from "context/PullToRefreshContext";
import TruckItem from "features/main/Trucks/modules/Item";
import { showErrorMessage } from "helpers/toastMessage";
import { ITruckData } from "models/Truck";
import { AppDispatch } from "store";
import { handleLoading } from "store/global/loader";
import { QUERY_SAVED_TRUCK_LIST } from "./query";
import styles from "./style.module.scss";

export default function SavedTrucks() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  //graphQL
  const { data, loading, error, refetch } = useQuery(QUERY_SAVED_TRUCK_LIST, {
    variables: {
      orderBy: "-created"
    },
    fetchPolicy: "cache-and-network"
  });
  usePullToRefresh(refetch);

  useEffect(() => {
    dispatch(handleLoading(loading));

    if (!loading && error) {
      showErrorMessage(error.message);
    }
  }, [loading]);

  const savedTruckList = useMemo(
    () => (data ? data.userSavedTrucks.data : []) as ITruckData[],
    [data]
  );

  function goDetails(id: string) {
    navigate(`${routes.TRUCKS_SEARCH}/${id}`, { state: { isSavedTruck: true } });
  }

  return (
    <ul className={styles.truckList}>
      {savedTruckList.length > 0 ? (
        savedTruckList.map((item) => (
          <TruckItem
            key={item.id}
            data={item}
            onClickDetails={goDetails}
            refresh={refetch}
            isSavedTruck
          />
        ))
      ) : (
        <div className={styles.truckEmptyList}>
          <img src={truckEmpty} alt="Empty saved truck" />
          <h3 className={styles.truckEmptyTitle}>No results found.</h3>
        </div>
      )}
    </ul>
  );
}
